import React from 'react';

import { useCurrentUser } from '@klp/auth';
import { Conditional } from '@klp/conditional';
import { useAppParams } from '@klp/core/app/useAppParams';
import { Heading } from '@klp/design';
import { Main } from '@klp/layout';

import { FakturaList } from '../components/FakturaList';
import { FakturaAccess } from '../config';

export const FakturaListView: React.FC = () => {
    const { selectedClient } = useAppParams();
    const { isAdmin, currentUser } = useCurrentUser();

    return (
        <Main>
            <Conditional
                condition={FakturaAccess(currentUser)}
                // eslint-disable-next-line react/jsx-no-useless-fragment
                errorComponent={<></>}
            >
                {isAdmin && selectedClient && (
                    <Heading
                        translation="faktura.invoicesFor"
                        translationOptions={{
                            kundeName: selectedClient.kundeName,
                            kundeNummer: selectedClient.kundeNummer,
                        }}
                        marginBottom="bulky"
                    />
                )}
                {!isAdmin && (
                    <Heading
                        translation="faktura.myInvoices"
                        marginBottom="bulky"
                    />
                )}

                <FakturaList />
            </Conditional>
        </Main>
    );
};
